import script from "./UserDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDrawer.vue?vue&type=script&setup=true&lang=js"

import "./UserDrawer.vue?vue&type=style&index=0&id=2d07df6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d07df6a"]])

export default __exports__